import { IRequestWithPageSortFilterSearch, TPageResponse } from 'redux/types';

export type TEmVatStore = {
	emVatList: TEmVatListResponse;
	emVatListLoading: boolean;
	createEmVatLoading: boolean;
	createEmVatSuccess: boolean;
	updateEmVatLoading: boolean;
	updateEmVatSuccess: boolean;
	deleteEmVatLoading: boolean;
	deleteEmVatSuccess: boolean;
};

export type TEmVatListItem = {
	id: number;
	emId: number;
	vatNumber: string;
	vatType: EVatType;
	address: string;
	name: string;
	countryId: number;
	countryCode: string;
};

export type TEmVatListRequest = IRequestWithPageSortFilterSearch;
export type TEmVatListResponse = TPageResponse<TEmVatListItem> | null;

export type TEmVatUpsertBody = {
	emId: number;
	vatNumber: string;
	address: string;
	name: string;
	countryId: number;
};

export enum EVatType {
	WAREHOUSE = 'WAREHOUSE',
	FIXED_ESTABLISHMENT = 'FIXED_ESTABLISHMENT',
}

export type TEmVatCreateRequest = {
	vatType: EVatType;
	body: TEmVatUpsertBody;
	listRequest?: TEmVatListRequest;
};
export type TEmVatUpdateRequest = {
	vatType: EVatType;
	id: number;
	body: TEmVatUpsertBody;
	listRequest?: TEmVatListRequest;
};
export type TEmVatDeleteRequest = {
	vatType: EVatType;
	id: number;
	listRequest?: TEmVatListRequest;
};
